import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="infinite-scroll"
// Automatically loads next page when scrolling to bottom
// Only enabled on mobile devices (screen width < 768px)
export default class extends Controller {
  static values = {
    scrollParent: String  // CSS selector for scrollable parent element
  }

  static targets = ["pagination"]

  connect() {
    // Only enable infinite scroll on mobile
    if (window.innerWidth >= 768) {
      return  // Desktop - show normal pagination
    }

    const navPagination = this.paginationTarget

    if (!navPagination) {
      return
    }

    const nextPageLink = navPagination.querySelector('ul li.next_page.page-item:not(.disabled) a.page-link')
    if (!nextPageLink) {
      return  // No more pages
    }

    this.nextPageUrl = nextPageLink.href

    this.scrollParent = document.querySelector(this.scrollParentValue)

    if (!this.scrollParent) {
      return
    }

    // Bind scroll handler
    this.handleScroll = this.handleScroll.bind(this)
    this.scrollParent.addEventListener('scroll', this.handleScroll, { passive: true })
  }

  disconnect() {
    if (this.scrollParent) {
      this.scrollParent.removeEventListener('scroll', this.handleScroll)
    }
  }

  handleScroll() {
    // Calculate scroll position - how far from bottom
    const scrollPosition = this.scrollParent.scrollTop + this.scrollParent.clientHeight
    const totalHeight = this.scrollParent.scrollHeight
    const threshold = 300 // pixels from bottom to trigger

    if (scrollPosition >= totalHeight - threshold) {
      // Remove event listener to prevent multiple requests
      this.scrollParent.removeEventListener('scroll', this.handleScroll)

      // Show loading indicator
      const navPagination = this.paginationTarget
      navPagination.innerHTML = "<img src='/loading.transparent.gif' alt='Loading...' >"

      // Fetch HTML partial and append rows
      fetch(this.nextPageUrl, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Infinite-Scroll': 'true'  // Signal to controller this is infinite scroll
        }
      })
      .then(response => response.text())
      .then(html => {
        this.appendResults(html)
      })
      .catch(error => {
        navPagination.innerHTML = ''
      })
    }
  }

  appendResults(html) {
    // Parse the HTML response
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    // Find the table rows in the response
    const newRows = doc.querySelectorAll('table#master_recordings tbody tr')
    const tbody = document.querySelector('table#master_recordings tbody')

    if (tbody && newRows.length > 0) {
      // Append each row
      newRows.forEach(row => tbody.appendChild(row))
    }

    // Update pagination - update the target's content directly to preserve Stimulus reference
    const newPagination = doc.querySelector('nav.pagination')

    if (newPagination) {
      // Update the pagination target's content directly, not its parent
      // This preserves the Stimulus target reference
      this.paginationTarget.innerHTML = newPagination.innerHTML

      // Check if there's a next page and re-setup infinite scroll
      // Only continue if there's a valid next page link (parent <li> not disabled)
      const nextPageLink = this.paginationTarget.querySelector('ul li.next_page.page-item:not(.disabled) a.page-link')
      if (nextPageLink && nextPageLink.href && nextPageLink.href !== '#') {
        this.nextPageUrl = nextPageLink.href
        this.scrollParent.addEventListener('scroll', this.handleScroll, { passive: true })
      } else {
        // No more pages - remove pagination altogether
        this.paginationTarget.innerHTML = ''
      }
    } else {
      // No more pages - remove pagination altogether
      this.paginationTarget.innerHTML = ''
    }
  }
}
